import React from 'react';
import NoReplenListData from 'src/pages/reportUsage/common/NoData';
import RowHeaderTemplateDesktop from './RowHeaderTemplateDesktop';
import RowTemplateDesktop from './RowTemplateDesktop';
import { useTranslation } from 'react-i18next';

const ReplenListViewDesktop = ({
    gridData,
    headerCheckboxClickHandler,
    checkboxClickHandler,
    quantityInputChangeHandler,
}) => {
    const { t } = useTranslation();
    const countryCode = localStorage.getItem('countryISOCode');
    return (
        <>
            <RowHeaderTemplateDesktop
                gridData={gridData}
                headerCheckboxClickHandler={headerCheckboxClickHandler}
                countryCode={countryCode}
            />
            {gridData && gridData.filter((x) => !x.accountOwned)?.length > 0 ? (
                gridData.map((item, idx) => {
                    return !item.accountOwned ? (
                        <RowTemplateDesktop
                            key={item.cfn}
                            item={item}
                            idx={idx}
                            countryCode={countryCode}
                            checkboxClickHandler={checkboxClickHandler}
                            quantityInputChangeHandler={
                                quantityInputChangeHandler
                            }
                        />
                    ) : null;
                })
            ) : (
                <NoReplenListData
                    content={t('replen.noItemToBeReplenished')}
                    padding="24px 14px"
                />
            )}
        </>
    );
};

export default ReplenListViewDesktop;
